
import {of as observableOf} from 'rxjs';
/**
 * Created by alexander schamne on 03.10.16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import {LocalizationService} from '../services'

@Injectable()
export class LanguageSwitchGuard  {
  constructor(private localizationService: LocalizationService) { }

  canActivate(route: ActivatedRouteSnapshot) {
    this.localizationService.setLanguage('');
    return observableOf(true);
  }
}
